const org = {
  orgName: '机构名称',
  integrator: '集成商名称',
  orgDescription: '机构描述',
  integratorDescription: '集成商描述',
  orgAddress: '机构地址',
  integratorAddress: '集成商地址',
  createTime: '创建时间',
  linkMan: '联系人',
  phone: '联系电话',
  email: '联系邮箱',
  usefulLife: '有效期',
  parentName: '上级',
  validateTip: {
    orgNameRequired: '请输入机构名称！',
    integratorRequired: '请输入集成商名称！',
    orgNameRule: '机构名称不超过30个字！',
    integratorRule: '集成商名称不超过30个字！',
    orgDescriptionRequired: '请输入机构描述！',
    integratorDescriptionRequired: '请输入集成商描述！',
    orgDescriptionRule: '机构描述应少于200字',
    integratorDescriptionRule: '集成商描述应少于200字',
    phoneRule: '请输入正确的电话号码格式',
    emailRule: '请输入正确的电子邮箱格式',
    linkManRule: '联系人名字过长',
    nickNameRequired: '请输入昵称！',
    nickNameRule: '昵称应在1-20个字之间！',
    userNameRequired: '用户名是必须的',
    userNameRule: '用户名的长度应在3-20字',
    passwordRequired: '密码是必须的',
    passwordRule: '密码长度应在6-15字',
    confirmPasswordRequired: '请确认密码',
    confirmPasswordRule: '两次输入的密码不一致',
  },
  editBasicInfo: '编辑基本信息',
  userInfo: '用户名',
  password: '密码',
  confirmPassword: '密码确认',
  editUserInfo: '编辑用户信息',
  userName: '用户名称',
  role: '所属角色',
  nickName: '昵称',
  autoRefresh: '登录过期',
  avatar: '用户头像',
  refresh: '自动刷新',
  autoOver: '固定时长',
  locationInfo: '位置信息',
  smsService: '短信服务',
  recharge: '充值',
  smsNum: '剩余短信',
  isShare: '是否共用',
  receiveUser: '接收人',
  receivePhone: '接收电话',
  rechargeSms: '短信充值',
  topUp: '充值',
  recycle: '回收',
  smsLabel: '请输入{text}条数',
  rechargeSuccess: '充值成功',
  errData: '充值数据不合法',
  customInfo: '订制信息',
  systemName: '系统名称',
  systemLogo: '系统图标',
  entityTemplate: '实体模板',
  enableShare: '已开启短信共享',
  disableShare: '已关闭短信共享',
  pre: '上一步',
  next: '下一步',
  addOrgSuccess: '新增机构成功',
  scenes: '关联场景',
  createUser:'新增用户',
  TopOrg:'顶级机构',
  Org:'下级机构',
  Attach:'子用户',
}
export default org
